module.exports = __webpack_public_path__ + "img/fonfor.fa3fe0d6.png";